.statusIconAndText {
    display: flex;
    gap: 10px;
    align-items: center;
}